import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Event sent when user creates boards from a template',
  name: 'board_templates_created',
  params: [
    {
      description: 'The template ID or generation prompt used',
      name: 'prompt',
      required: true,
      type: 'string',
    },
    {
      description: 'The number of boards created',
      name: 'number_of_boards',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
